import { clearFormProgress, formProgressSync } from "../utils/formProgress";
import { handleSubmitBtnState, showSwalMessage } from "../utils/helpers";

const form = document.querySelector("form");
const formSyncId = "contact_us_form";

// FORM PROGRESS SYNC
formProgressSync(form, formSyncId);
// FORM PROGRESS SYNC  END

// SWEET ALERT
const onOpenCb = () => {
  clearFormProgress(form, formSyncId);
};
const swalAlertMsg = `<h5 class='text-base mobile:text-sm'>🎉🎉🎉 <br />Thank you for reaching out to us. Do expect to hear from us soonest<br/> <b>Cheers</b></h5>`;
showSwalMessage(swalAlertMsg, onOpenCb);

//   ADD EVENT LISTENER TO FORM
form.addEventListener("submit", (e) => {
  const button = form.querySelector(".submit-btn");
  handleSubmitBtnState(button);
});
